import { CountryCode } from '~/enums';
import { homePageByMarket } from '~/constants/markets';
import { Language } from '~/store/types/sharedTypes';

export const openQredHomePage = (market: CountryCode, language: Language) => {
  const url = homePageByMarket[market][language];
  window.open(
    url,
    market === CountryCode.NL ? 'qeldHome' : 'qredHome',
    'noopener'
  );
};

const GERMAN_ONLY_APP_STORE_URL =
  'https://apps.apple.com/de/app/qred/id6788032620';
const GERMAN_ONLY_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.qred.oneqred';

const ONEQRED_APP_STORE_URL = 'https://apps.apple.com/se/app/qred/id1528985194';
const ONEQRED_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.qred';
const APP_STORE_URL_WITHOUT_REGION =
  'https://apps.apple.com/app/qred/id1528985194';

interface AppStoreUrlOptions {
  market: CountryCode;
  language: Language;
  usesGermanOnlyApp: boolean;
}

export const getAppStoreUrl = ({
  market,
  language,
  usesGermanOnlyApp,
}: AppStoreUrlOptions): string => {
  if (usesGermanOnlyApp) {
    return GERMAN_ONLY_APP_STORE_URL;
  }
  if (market === CountryCode.DE) {
    return APP_STORE_URL_WITHOUT_REGION;
  }
  switch (language) {
    case Language.Swedish:
      return ONEQRED_APP_STORE_URL;
    case Language.Finnish:
      return `${ONEQRED_APP_STORE_URL}?l=fi`;
    default:
      return `${ONEQRED_APP_STORE_URL}?l=en`;
  }
};

export const getGooglePlayUrl = (usesGermanOnlyApp: boolean): string =>
  usesGermanOnlyApp ? GERMAN_ONLY_GOOGLE_PLAY_URL : ONEQRED_GOOGLE_PLAY_URL;

export const openAppStore = (options: AppStoreUrlOptions) => {
  window.open(getAppStoreUrl(options), 'appStore', 'noopener');
};

export const openGooglePlay = (usesGermanOnlyApp: boolean) => {
  window.open(getGooglePlayUrl(usesGermanOnlyApp), 'googlePlay', 'noopener');
};
